import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { apiMiddleware as reduxApiMiddleware } from 'redux-api-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import { tracking as paymentsMiddlewareTracking } from '@common/middleware/tracking';

export default function configureStore(initialState, history, rootReducer) {
  let finalCreateStore;
  if (__DEV__) {
    finalCreateStore = composeWithDevTools(
      applyMiddleware(require('redux-immutable-state-invariant')()),
      __BROWSER__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,
      applyMiddleware(thunk),
      applyMiddleware(reduxApiMiddleware),
      applyMiddleware(paymentsMiddlewareTracking),
    )(createStore);
  } else {
    finalCreateStore = compose(
      applyMiddleware(thunk),
      applyMiddleware(reduxApiMiddleware),
      applyMiddleware(paymentsMiddlewareTracking),
      __BROWSER__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,
    )(createStore);
  }
  return finalCreateStore(rootReducer, initialState);
}
